import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatCredits } from '../credits/utils/formatCredits';

type CampaignsCreditPackageCardProps = {
  title: string;
  volume: number;
  priceLabel: string;
  vatLabel: string;
  ctaLabel: string;
  volumeUnit: string;
  isPopular?: boolean;
  savingsBadge?: string;
  onRequest: VoidFunction;
};

export const CampaignsCreditPackageCard: FC<CampaignsCreditPackageCardProps> = ({
  title,
  volume,
  priceLabel,
  vatLabel,
  ctaLabel,
  volumeUnit,
  isPopular = false,
  savingsBadge,
  onRequest,
}) => {
  const { t, i18n } = useTranslation('campaign');

  return (
    <article
      className={`relative flex min-w-[220px] flex-col rounded-[14px] border bg-white-100 p-6 ${
        isPopular ? 'border-2 border-brand-600' : 'border-secondary-border'
      }`}
    >
      {isPopular ? (
        <span className='absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand-600 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] text-white-100'>
          {t('credits.packages.recommended')}
        </span>
      ) : null}
      {savingsBadge ? (
        <span className='absolute right-4 top-4 rounded-full bg-emerald-100 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.08em] text-emerald-800'>
          {savingsBadge}
        </span>
      ) : null}

      <p className='text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{title}</p>
      <p className='mt-2 text-3xl font-extrabold tracking-tight text-slate-900'>{formatCredits(volume, i18n.language)}</p>
      <p className='text-xs text-secondary-500'>{volumeUnit}</p>
      <p className='mt-3 text-xl font-semibold text-slate-900'>{priceLabel}</p>
      <p className='text-xs text-secondary-500'>{vatLabel}</p>

      <button
        type='button'
        onClick={onRequest}
        className={`mt-5 h-10 rounded-lg border px-3 text-sm font-semibold transition-colors ${
          isPopular
            ? 'border-brand-600 bg-brand-600 text-white-100 hover:bg-brand-700'
            : 'border-secondary-border text-slate-800 hover:bg-gray-50'
        }`}
      >
        {ctaLabel}
      </button>
    </article>
  );
};
